import { ChangeEvent, forwardRef } from 'react';
import { HiddenFileInput } from '../style';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useUploadCustomMap } from 'hooks/api/customMap/useUploadCustomMap';
import { appToast } from 'components/Basic/CustomToast';

const CustomMapUploadInput = forwardRef<HTMLInputElement>((_, ref) => {
	const { uuid, imgHeight, imgWidth } = useSelector((rs: RootState) => rs.roofData.data);
	const { mutateAsync: uploadCustomMap, isLoading: isUploading } = useUploadCustomMap(uuid);

	async function onFileSelect(event: ChangeEvent<HTMLInputElement>) {
		event.stopPropagation();
		const file = event.target.files?.[0];
		if (!file) return;

		if (file.size / 1024 / 1024 > 10) {
			appToast.error('File size cannot exceed 10MB.');
			event.target.value = '';
			return;
		}

		if (!file.type.startsWith('image/')) {
			appToast.error('Only image files are allowed.');
			event.target.value = '';
			return;
		}

		const customMap = createCustomMap();

		await uploadCustomMap({
			file,
			x: customMap.x,
			y: customMap.y,
		});
		event.target.value = '';
	}

	function createCustomMap() {
		const originalCenter = {
			x: imgWidth / 2,
			y: imgHeight / 2,
		};

		// const scaleX = imageDimensions.width / originalPxWidth;
		// const scaleY = imageDimensions.height / orginalPxHeight;

		return {
			x: originalCenter.x,
			y: originalCenter.y,
			// scaleX: (imgWidth/customImg.width)*0.25,
			// scaleY:(imgWidth/customImg.height)*0.25
		};
	}

	return (
		<HiddenFileInput
			ref={ref}
			id="file-uploader"
			type="file"
			accept="image/*"
			onChange={onFileSelect}
			disabled={isUploading}
		/>
	);
});

CustomMapUploadInput.displayName = 'CustomMapUploadInput';
export default CustomMapUploadInput;